export default __webpack_public_path__ + "static/media/alex.2cc83b47.png";